import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';
import TopContributorsOffersRanking from 'components/TopContributorsOffersRanking';

const MyOffersSidebar = ({ className, gaEventCategory, ...rest }) => {
  const topContributorsOfferRanking = useRef(null);

  return (
    <Sidebar
      className={className}
      refsToBeIgnoredBeforeFixing={[topContributorsOfferRanking]}
      {...rest}
    >
      <TopContributorsOffersRanking
        ref={topContributorsOfferRanking}
        gaEventCategory={gaEventCategory}
      />
    </Sidebar>
  );
};

MyOffersSidebar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default MyOffersSidebar;
